import { log } from '@/utils/log';
import { onMounted, onUnmounted, ref } from 'vue';

export function useNetworkStatus() {
    const isOnline = ref(navigator.onLine);

    const handleOnline = () => {
        log('Network status: online');
        isOnline.value = true;
    };

    const handleOffline = () => {
        log('Network status: offline');
        isOnline.value = false;
    };

    onMounted(() => {
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);
    });

    onUnmounted(() => {
        window.removeEventListener('online', handleOnline);
        window.removeEventListener('offline', handleOffline);
    });

    return {
        isOnline,
    };
}
